import { render } from "./EvaOpportunities.vue?vue&type=template&id=1004fedb"
import script from "./EvaOpportunities.vue?vue&type=script&lang=js"
export * from "./EvaOpportunities.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__